exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#inbox-page > *[data-v-c4ea80c0]:nth-child(1) {\n  flex: 0.15;\n  min-width: 270px;\n}\n#inbox-page > *[data-v-c4ea80c0]:nth-child(2) {\n  flex: 0.85;\n}", ""]);

// exports
